import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";

import { tradeAttachmentsQueryKey } from "./useTradeAttachments";

export type DeleteAttachmentVariables = {
  attachmentId: string;
  tradeId: string;
};

export function useDeleteAttachment() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<void, Error, DeleteAttachmentVariables>({
    mutationFn: async ({ attachmentId }) => {
      const { error } = await client.DELETE(
        "/api/attachments/{attachment_id}",
        { params: { path: { attachment_id: attachmentId } } },
      );
      if (error !== undefined) {
        throw new Error(`Failed to delete attachment ${attachmentId}`);
      }
    },
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: tradeAttachmentsQueryKey(variables.tradeId),
      });
    },
  });
}
